import React, { useState } from "react";

// import JS files
import MuiButton from "../../shares/MuiButton";

const AdminProviderOrderCard = ({
  item,
  children,
  update_ring_item,
  showColorGender,
  showAcceptBtn,
}) => {
  const [editable, setEditable] = useState(false);

  return (
    <>
      <div className="panel-card mt-2">
        <div className="grid md:grid-cols-2 mt-3">
          <div className="mt-2 md:mt-0 flex items-center">
            <div className="grid grid-cols-1 md:grid-cols-2 ">
              <div className="flex items-center">
                <span className="show-label mx-2 shrink-0">
                  کد: <span className="show-value"> {item.bangle.code}</span>
                </span>
                <span className="show-label mx-2 shrink-0">
                  اسم:{" "}
                  <span className="show-value"> {item.bangle.show_name}</span>
                </span>
                <span className="show-label mx-2 shrink-0">
                  برند:{" "}
                  <span className="show-value"> {item.bangle.brand_name}</span>
                </span>
                {showColorGender && (
                  <>
                    <span className="show-label mx-2 shrink-0">
                      رنگ:{" "}
                      <span className="show-value">
                        {" "}
                        {item.color == "yellow" ? "زرد" : "سفید"}
                      </span>
                    </span>
                    <span className="show-label mx-2 shrink-0">
                      نوع:{" "}
                      <span className="show-value">
                        {" "}
                        {item.gender == "woman" ? "زنانه" : "بچه گانه"}
                      </span>
                    </span>
                  </>
                )}
              </div>
            </div>
          </div>
          {children}
        </div>
        {showAcceptBtn ? (
          <div className="grid md:flex md:justify-between md:items-center mt-6">
            <MuiButton
              onClick={() => update_ring_item(item.id)}
              variant="contained"
              color="primary"
              text="تایید"
              htmlType="submit"
              disabled={editable ? true : false}
              isFullWidth={true}
            />
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default AdminProviderOrderCard;
